<template>
  <div class="sf-auth-page">
    <div class="sf-auth-glow-a" />
    <div class="sf-auth-glow-b" />

    <div class="sf-auth-container">
      <div
        v-if="empresaLogo"
        class="sf-auth-logo-row"
      >
        <b-img
          :src="empresaLogo"
          alt="logo"
        />
      </div>

      <div class="sf-auth-card">
        <div class="sf-auth-head">
          <div class="sf-auth-eyebrow">
            {{ appName }}
          </div>
          <h1 class="sf-auth-title">
            Bem vindo !
          </h1>
          <p class="sf-auth-subtitle">
            Acesse sua conta
          </p>
        </div>

        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="sf-auth-form"
            @submit.prevent="login"
          >
            <!-- Usuário (impersonate) -->
            <validation-provider
              #default="{ errors }"
              name="usuario"
              rules="required|email"
            >
              <div class="sf-field">
                <label for="usuario">Usuário</label>
                <div class="sf-input-wrap">
                  <feather-icon
                    icon="UserIcon"
                    class="sf-input-icon"
                  />
                  <b-form-input
                    id="usuario"
                    v-model="impersonate"
                    name="login-usuario"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john@example.com"
                    autofocus
                  />
                </div>
                <small
                  v-if="errors[0]"
                  class="sf-error"
                >{{ errors[0] }}</small>
              </div>
            </validation-provider>

            <!-- Email -->
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="required|email"
            >
              <div class="sf-field">
                <label for="email">Email</label>
                <div class="sf-input-wrap">
                  <feather-icon
                    icon="MailIcon"
                    class="sf-input-icon"
                  />
                  <b-form-input
                    id="email"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="voce@empresa.com"
                  />
                </div>
                <small
                  v-if="errors[0]"
                  class="sf-error"
                >{{ errors[0] }}</small>
              </div>
            </validation-provider>

            <!-- Senha -->
            <validation-provider
              #default="{ errors }"
              name="Password"
              rules="required"
            >
              <div class="sf-field">
                <div class="sf-field-headrow">
                  <label for="password">Senha</label>
                  <b-link
                    :to="{name:'recuperar-senha'}"
                    class="sf-forgot-link"
                  >
                    Esqueceu a senha?
                  </b-link>
                </div>
                <div class="sf-input-wrap has-toggle">
                  <feather-icon
                    icon="LockIcon"
                    class="sf-input-icon"
                  />
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="••••••••"
                    autocomplete="off"
                  />
                  <feather-icon
                    class="sf-toggle-btn"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </div>
                <small
                  v-if="errors[0]"
                  class="sf-error"
                >{{ errors[0] }}</small>
              </div>
            </validation-provider>

            <!-- Submit Button -->
            <button
              type="submit"
              class="sf-submit-btn"
              :disabled="invalid"
            >
              Entrar
              <feather-icon icon="ArrowRightIcon" />
            </button>
          </b-form>
        </validation-observer>

        <div class="sf-recaptcha-note">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a>
          and
          <a href="https://policies.google.com/terms">Terms of Service</a>
          apply
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BFormInput, BLink, VBTooltip, BImg,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import useJwt from '@/auth/jwt/useJwt'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true,
  },
})

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    // BSV
    BForm,
    BFormInput,
    BLink,
    BImg,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],

  data() {
    return {
      userEmail: '',
      password: '',
      token: '',
      impersonate: '',
      // validation rules
      required,
      email,
    }
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },

  setup() {
    const { empresa, empresaLogo } = useAppConfig()
    const { appName } = $themeConfig.app

    return {
      empresa,
      empresaLogo,
      appName,
    }
  },

  methods: {

    recaptcha() {
      const self = this
      this.$recaptchaLoaded().then(() => {
        this.$recaptcha('login').then(token => {
          this.token = token
          useJwt.login({
            email: this.userEmail,
            senha: this.password,
            token: this.token,
            impersonate: this.impersonate,
          }).then(response => {
            useJwt.setToken(response.data.token)
            useJwt.setImpersonate(self.impersonate)
            localStorage.setItem('userData', JSON.stringify(response.data))

            const products = []

            response.data.ability.forEach(value => {
              if (value.subject === 'assinante') {
                products.push('spot')
              } else if (value.subject === 'assinante-futures') {
                products.push('futures')
              }
            })

            localStorage.setItem('cb-context', response.data.contexto.toLowerCase())
            localStorage.setItem('cb-products', JSON.stringify(products))

            self.$ability.update(response.data.ability)
            this.$router.replace(getHomeRouteForLoggedInUser(response.data.perfil))
          }).catch(() => {
            this.$swal({
              title: 'Erro!',
              text: ' E-mail e/ou senha incorretos.',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          })
        })
      })
    },

    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.recaptcha()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-sweetalert.scss';

/* ============================================================
   Autenticação — padrão Soulf (dark premium).
   design_handoff_soulf_redesign/reference/Login.dc.html
   ============================================================ */
.sf-auth-page {
  min-height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
  font-family: 'Geist', sans-serif;
}

.sf-auth-glow-a {
  position: absolute;
  width: 520px; height: 520px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.08);
  filter: blur(90px);
  top: -160px; right: -120px;
  pointer-events: none;
}
.sf-auth-glow-b {
  position: absolute;
  width: 420px; height: 420px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.06);
  filter: blur(90px);
  bottom: -140px; left: -100px;
  pointer-events: none;
}

.sf-auth-container {
  width: 100%;
  max-width: 420px;
  position: relative;
  z-index: 1;
}

.sf-auth-logo-row {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;

  img { max-width: 280px; width: 100%; height: auto; object-fit: contain; }
}

.sf-auth-card {
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 20px;
  padding: 36px 34px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
  }
}

.sf-auth-head { margin-bottom: 28px; }
.sf-auth-eyebrow {
  font-family: 'Geist Mono', 'SFMono-Regular', Menlo, monospace;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 10px;
}
.sf-auth-title {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.02em;
  margin: 0 0 6px;
}
.sf-auth-subtitle {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.5;
  margin: 0;
}

.sf-auth-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sf-field + .sf-field { margin-top: 0; }
.sf-field label {
  display: block;
  font-size: 12.5px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.70);
  margin-bottom: 7px;
}
.sf-field-headrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;

  label { margin-bottom: 0; }
}
.sf-forgot-link {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  &:hover { color: #fff; text-decoration: none; }
}

.sf-input-wrap {
  position: relative;

  .sf-input-icon {
    position: absolute;
    left: 13px; top: 50%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.35);
    pointer-events: none;
    width: 16px; height: 16px;
  }

  ::v-deep .form-control,
  ::v-deep input.form-control {
    width: 100%;
    background: rgba(255, 255, 255, 0.04) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    border-radius: 9px !important;
    padding: 11px 13px 11px 38px !important;
    height: auto !important;
    color: #fff !important;
    font: 400 13.5px 'Geist', sans-serif !important;
    box-shadow: none !important;
    transition: border-color .15s ease, box-shadow .15s ease;

    &::placeholder { color: rgba(255, 255, 255, 0.35) !important; }
    &:focus {
      border-color: rgba(59, 130, 246, 0.6) !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;
    }
    &.is-invalid { border-color: #ef4444 !important; }
  }

  &.has-toggle ::v-deep .form-control { padding-right: 40px !important; }

  .sf-toggle-btn {
    position: absolute;
    right: 6px; top: 50%;
    transform: translateY(-50%);
    width: 30px; height: 30px;
    display: flex; align-items: center; justify-content: center;
    color: rgba(255, 255, 255, 0.40);
    cursor: pointer;
    border-radius: 7px;
    transition: color .15s ease;
    &:hover { color: #fff; }
  }
}

.sf-error {
  color: #f87171;
  font-size: 12px;
  margin-top: 6px;
  display: block;
}

.sf-submit-btn {
  margin-top: 6px;
  width: 100%;
  border: none;
  background: #3b82f6;
  color: #fff;
  font: 600 13.5px 'Geist', sans-serif;
  padding: 12px 0;
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 0 32px rgba(59, 130, 246, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.15), inset 0 -1px 0 rgba(0, 0, 0, 0.25);
  transition: transform .15s ease, box-shadow .15s ease, opacity .15s ease;

  .feather { width: 16px; height: 16px; }

  &:hover:not(:disabled) { transform: translateY(-2px); }
  &:disabled { opacity: 0.5; box-shadow: none; cursor: not-allowed; transform: none; }
}

.sf-recaptcha-note {
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.5;
  text-align: center;

  a {
    color: rgba(255, 255, 255, 0.55);
    &:hover { color: #fff; text-decoration: underline; }
  }
}

.sf-back-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 22px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);

  .feather { width: 15px; height: 15px; }
  &:hover { color: #fff; text-decoration: none; }
}

.sf-error-fade-enter-active, .sf-error-fade-leave-active { transition: all .2s ease; }
.sf-error-fade-enter, .sf-error-fade-leave-to { opacity: 0; transform: translateY(-6px); }

@media (max-width: 480px) {
  .sf-auth-card { padding: 28px 22px; border-radius: 16px; }
}
</style>
